// extracted by mini-css-extract-plugin
module.exports = {"container":"ft-z","productName":"gt-z","modal":"ht-z","dimensions":"it-z","recipientEmail":"jt-z","lowStock":"kt-z","recommendedFit":"lt-z","notRecommendedFit":"mt-z"};